import { SocketEvent } from "@app/constants";
import { Environment } from "@environments/environment";
import { Observable } from "rxjs";
import { io, ManagerOptions, Socket, SocketOptions } from "socket.io-client";

class _SocketService {
  private socket!: Socket;

  public connect(options?: Partial<ManagerOptions & SocketOptions>) {
    const socketUrl = Environment.SOCKET_URL as string;

    const newOptions: Partial<ManagerOptions & SocketOptions> = {
      ...options,
    };

    if (!newOptions.transports || !newOptions.transports.length) {
      newOptions.transports = ["polling"];
    }

    if (!this.socket) {
      this.socket = io(socketUrl, newOptions);
    }
  }

  public emit(event: string, data: any) {
    if (!this.socket) return;

    this.socket.emit(event, data);
  }

  public onDeviceJoin(): Observable<string> {
    return new Observable((observer) => {
      if (!this.socket) return;

      this.socket.on("device_join", (data) => observer.next(data));
    });
  }

  public onDeviceDisconnect(): Observable<string> {
    return new Observable((observer) => {
      if (!this.socket) return;

      this.socket.on("device_disconnect", (data) => observer.next(data));
    });
  }

  public onDeviceWorking(): Observable<string> {
    return new Observable((observer) => {
      if (!this.socket) return;

      this.socket.on("device_working", (data) => observer.next(data));
    });
  }

  public onDeviceDone(): Observable<string> {
    return new Observable((observer) => {
      if (!this.socket) return;

      this.socket.on("device_done", (data) => observer.next(data));
    });
  }
}

const SocketService = new _SocketService();

export default SocketService;
